import { useQuery } from '@apollo/client/react'
import Stepper from '@mui/material/Stepper'
import Step from '@mui/material/Step'
import StepLabel from '@mui/material/StepLabel'
import { useOnboardingLayoutContext } from 'routes/components/OnboardingLayout/hooks/useOnboardingLayoutContext/useOnboardingLayoutContext'
import { getLabelByStep } from './helpers/getLabelByStep/getLabelByStep'
import { OnboardingStepperDocument } from './OnboardingStepper.graphql'

export const OnboardingStepper = () => {
  const { flowType } = useOnboardingLayoutContext()

  const { data: { onboardingFlows = [] } = {} } = useQuery(OnboardingStepperDocument)
  const onboardingFlow = onboardingFlows.find((flow) => flow.flowType === flowType)

  if (!onboardingFlow) {
    return null
  }

  const { orderedSteps } = onboardingFlow
  const activeStep = onboardingFlow.currentStep ? orderedSteps.indexOf(onboardingFlow.currentStep) : orderedSteps.length

  return (
    <Stepper
      activeStep={activeStep}
      alternativeLabel={true}
      data-testid="onboarding-stepper"
      sx={{
        marginBottom: 1,
        width: '500px',
        marginX: 'auto',
      }}
    >
      {orderedSteps.map((step, idx) => {
        const isActive = idx === activeStep

        return (
          <Step key={step}>
            <StepLabel data-testid={`onboarding-step-label-${step}${isActive ? '-active' : ''}`}>
              {getLabelByStep(step)}
            </StepLabel>
          </Step>
        )
      })}
    </Stepper>
  )
}
